import { Grid, GridProps, Stack, styled } from "@mui/material";
import { IconButtonIcons } from "@smartrr/shared/customerPortal/components/AquariusIconButton";
import { NestedKeyOfShallow } from "@smartrr/shared/utils/sharedTranslations/localize";
import { localizeDefault } from "@smartrr/shared/utils/sharedTranslations/localizeDefault";
import React from "react";

import { ValidViews } from "./OrderOptionsModalInner";

export const SELECTED_CLASS = "icon-selected";
export const CENTERED_CLASS = "icon-center";
export const ACTIVE_CLASS = "icon-active";

interface IButtonGridProps extends GridProps {
  isMobile: boolean;
  children?: React.ReactNode;
}

export const ButtonGrid = styled(
  React.forwardRef<HTMLDivElement, IButtonGridProps>(({ isMobile, ...props }: IButtonGridProps, ref) => (
    <Grid ref={ref} {...props} />
  ))
)<{
  isMobile: boolean;
}>`
  flex-flow: row;
  overflow: scroll;
  padding: 7.5px 0;

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 0px;
    height: 5px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }

  & .MuiGrid-item {
    width: 80px;
    padding: 7.5px 0px;
    margin: 0 19px;
  }
  & [class*="icon-selected"] {
    position: absolute;
    transition: 0.5s ease-in-out;
  }
  & [class*="icon-active"] {
    left: 40% !important;
    pointer-events: none;
  }
  & [class*="icon-center"] {
    pointer-events: none;
  }

  &[class*="just-center"] {
    justify-content: center;
  }
`;

export const StyledStack = styled(Stack)<{ active: boolean; isMobile: boolean }>`
  align-items: center;
  border: 1px solid
    ${({ active, theme }) =>
      active ? theme.modernPrimaryButtonBorderColor : theme.modernSecondaryButtonBorderColor};
  border-radius: ${({ theme }) => theme.modernButtonBorderRadius ?? 0 * 2}px;
  cursor: pointer;
  flex-direction: column;
  justify-content: center;
  min-width: 211px;
  overflow: hidden;
  transition: 0.3s ease-in-out;
  width: ${({ isMobile }) => (isMobile ? "100%" : "231px")};

  & .inner,
  & .selection-icon {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  & .inner {
    padding: 40px 10px;
    row-gap: 10px;
  }

  & .selection-icon {
    background-color: ${({ theme, active }) =>
      active ? theme.modernPrimaryButtonColor : theme.modernSecondaryButtonColor};
    border-top: 1px solid
      ${({ theme, active }) =>
        active ? theme.modernPrimaryButtonBorderColor : theme.modernSecondaryButtonBorderColor};
    padding: 10px 20px;
    transition: 0.3s ease-in-out;
    width: 100%;
  }
`;

export interface ButtonAction {
  iconName: IconButtonIcons;
  label: NestedKeyOfShallow<typeof localizeDefault>;
  view: ValidViews;
}

// * Order Options Button Options
export const orderNowObj: ButtonAction = {
  iconName: "shippingBox",
  label: "sendNow",
  view: "Order now",
};

export const skipObj: ButtonAction = {
  iconName: "skip",
  label: "skip",
  view: "Skip",
};

export const unskipObj: ButtonAction = {
  iconName: "unskip",
  label: "unskip",
  view: "Skip",
};

export const giftObj: ButtonAction = {
  iconName: "gift",
  label: "gift",
  view: "Gift",
};

export const ungiftObj: ButtonAction = {
  iconName: "stop",
  label: "ungift",
  view: "Gift",
};

export const swapObj: ButtonAction = {
  iconName: "swap",
  label: "swapItem",
  view: "Swap item",
};

export const delayDateObj: ButtonAction = {
  iconName: "clock",
  label: "delayDate",
  view: "Delay date",
};

export const editAddressObj: ButtonAction = {
  iconName: "house",
  label: "editAddress",
  view: "Edit address",
};

// * Manage Subscriptions Button Options *

export const changeFreqObj: ButtonAction = {
  iconName: "calendarClock",
  label: "editFreq",
  view: "Edit frequency",
};

export const cancelObj: ButtonAction = {
  iconName: "stop",
  label: "cancel",
  view: "Cancel",
};

export const setDateObj: ButtonAction = {
  iconName: "calendar",
  label: "setDate",
  view: "Set next date",
};

export const editPaymentObj: ButtonAction = {
  iconName: "wallet",
  label: "editPayment",
  view: "Edit payment",
};

export const pauseObj: ButtonAction = {
  iconName: "pause",
  label: "pause",
  view: "Pause",
};

export const resumeObj: ButtonAction = {
  iconName: "resume",
  label: "unpause",
  view: "Resume",
};
